const linkResolver = doc => {
	if (doc.link_type === 'Web') {
		return doc.url
	}
	else {
		if (doc.type === 'homepage') {
			return `/`
		}
		else if (doc.type === 'abou') {
			return `/about`
		}
		else if (doc.type === 'solution') {
			return `/solution/${doc.uid}`
		}
		else if (doc.type === 'product') {
			return `/product/${doc.uid}`
		}
		else if (doc.type === 'article') {
			return `/article/${doc.uid}`
		}
		else if (doc.type === 'legal') {
			return `/legal/${doc.uid}`
		}
		return `/${doc.type}`
	}
}

module.exports = linkResolver